const getProductsSpecs = products => {
  if (!products) return [];
  const result = [];
  products.forEach(product => {
    const productType = product.type;
    if (productType === 'PageProduct') {
      product.productSpecs?.forEach(productSpec => {
        if (!result.some(s => s.type === productSpec.type && s.value === productSpec.value)) {
          result.push(productSpec);
        }
      });
    }
    if (productType === 'PageProductBundle') {
      product.products?.forEach(bundleProduct => {
        bundleProduct.productSpecs?.forEach(productSpec => {
          if (!result.some(s => s.type === productSpec.type && s.value === productSpec.value)) {
            result.push(productSpec);
          }
        });
      });
    }
  });

  return result;
};

export default getProductsSpecs;
